import React from 'react';
import { Button } from '../ui/button';
import { X, DownloadSimple } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PdfPreviewModal({ previewProvince, previewUrl, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" data-testid="pdf-preview-overlay">
      <div className="bg-white rounded-sm w-full max-w-4xl h-[85vh] flex flex-col shadow-2xl">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h3 className="text-lg font-bold text-slate-900">
            Anteprima Comunicazione - Provincia {previewProvince}
          </h3>
          <div className="flex items-center gap-2">
            <Button
              size="sm"
              variant="outline"
              onClick={() => window.open(`${API_URL}/api/communications/${previewProvince}/download-pdf`, '_blank')}
              className="rounded-sm text-xs"
              data-testid="preview-download-pdf"
            >
              <DownloadSimple size={14} className="mr-1.5" /> Scarica PDF
            </Button>
            <button onClick={onClose} className="p-1.5 hover:bg-slate-100 rounded" data-testid="preview-close">
              <X size={20} className="text-slate-500" />
            </button>
          </div>
        </div>
        <div className="flex-1 bg-slate-100 p-2">
          {previewUrl ? (
            <iframe
              src={previewUrl}
              className="w-full h-full rounded-sm border border-slate-200"
              title={`Anteprima comunicazione ${previewProvince}`}
              data-testid="pdf-preview-iframe"
            />
          ) : (
            <div className="flex items-center justify-center h-full">
              <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-[#0A2540] border-r-transparent"></div>
              <span className="ml-3 text-sm text-slate-600">Caricamento anteprima...</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
